import { cn } from '@fshr/shared-react';
import Image from '../image';

interface AvatarProps {
	avatar?: string | null;
	initials?: string | null;
	className?: string;
	intialsClassName?: string;
	staticImage?: boolean;
}

export default function Avatar({
	avatar,
	initials,
	className,
	intialsClassName,
	staticImage = false,
}: AvatarProps) {
	return (
		<div
			className={cn(
				[
					'bg-neutral-300',
					'rounded-full',
					'h-600',
					'w-600',
					'flex',
					'justify-center',
					'items-center',
					'md:h-750',
					'md:w-750',
					'leading-none',
					'uppercase',
					'font-sans',
					'font-[300]',
					'text-[28px]',
					'tracking-[0.03em]',
					'md:text-[36px]',
					'md:tracking-[0.08em]',
				],
				className,
				{ 'relative overflow-hidden': avatar }
			)}
		>
			{avatar ? (
				<Image
					roughSize="s"
					src={avatar}
					staticImage={staticImage}
					alt=""
					className="absolute inset-0 h-full w-full object-cover"
				/>
			) : (
				<p className={intialsClassName}>{initials}</p>
			)}
		</div>
	);
}
